<div class="w-full">
  <div *ngIf="totalProperties > 7">
    <mat-form-field class="w-full" appearance="outline">
      <ui-icon icon="griddy-search" [size]="18" matPrefix class="text-gray-400 ml-2"></ui-icon>
      <input matInput type="text" placeholder="Search..." [formControl]="searchTerm" />
    </mat-form-field>
  </div>

  <div class="max-h-[800px] overflow-y-auto">
    <mat-radio-group class="flex flex-col gap-2" [disabled]="disabled" [value]="value" (change)="onRadioChange($event)">
      @for (p of filteredProperties$ | async; track p.id) {
        <mat-radio-button class="py-3 px-2 rounded-lg border border-gray-200" [value]="p.id">
          <div class="flex items-center gap-3">
            <img [src]="p.picture" alt="" class="h-8 w-8 rounded object-cover" onerror="this.style.display='none'" />
            <div class="text-sm text-gray-700">
              {{ p.name }}
            </div>
          </div>
        </mat-radio-button>
      }
    </mat-radio-group>

    @if (loading$ | async) {
      <div class="p-4 text-center">
        <ui-loading-spinner></ui-loading-spinner>
      </div>
    }

    @if ((loading$ | async) !== true) {
      <div class="p-4 text-center text-sm text-gray-400 italic">
        <p *ngIf="filteredProperties$ | async as filteredProperties">
          {{ filteredProperties.length === totalProperties ? 'All' : filteredProperties.length }} of
          {{ totalProperties }} properties
        </p>
      </div>
    }
  </div>
</div>
